import { UiService } from 'src/app/services/ui.service';
// import { Account, Label } from '../accounts.era';
// import { JoiEvent } from '../events.era';
// import { AppState } from '../store';
import { createSelector } from '@ngrx/store';
import { accountStateSelector } from '../accounts.era';
// import { makeMapFromListOfObjectsAndKey } from '../../helpers/helpers';
import { User, UserSettings } from '../../../../globals/store/user.data';
import { invitedToEventsReselector } from './filteredEvents.reselector';
import { Dictionary } from '@ngrx/entity';
// import { UserSettings } from '../user.data';
import { Account, AccountIssueDisplayData, AccountPublicInfo, activeDocketStatuses, JoiAccount } from '../../../../globals/store/accounts.data';
import { userStateSelector } from '../user.era';
import { makeMapFromListOfObjectsAndKey, sortByProp } from 'globals/helpers/helpers';
import { settingsStateSelector } from '../settings.era';
import { Label } from 'globals/store/events.data';
import { workforceStateSelector } from '../workforce.era';
import { contactsStateSelector } from '../contacts.era';
// import { JoiAccount } from 'src/app/store/accounts.data';
// import { sortByProp } from './../../helpers/helpers';
const accountEntities = createSelector(accountStateSelector,(state)=> state.entities)
const account = createSelector(accountStateSelector, (state) => state.account);
const accountIds = createSelector(accountStateSelector, (state) => state.ids);
const user = createSelector(userStateSelector, (state) => state.user);
const userSettings = createSelector(settingsStateSelector, (state) => state.user);
const workforce = createSelector(workforceStateSelector, (state) => state.workforce);
const accountIdListByEmail = createSelector(contactsStateSelector, (state) => state.accountIdListByEmail);
const accountsLoading = createSelector(accountStateSelector, (state) => state.loading);
const justInvitedAccountIds = createSelector(accountStateSelector, (state) => state.justInvitedIds);
const selectedBudgetAccount = createSelector(accountStateSelector, (state) => state.selectedBudgetAccount);

export const accountListSelector = createSelector(accountEntities,(accounts)=>[...Object.values(accounts)].sort(sortByProp('title')))


export const activeAccountListReselector = createSelector(
  accountListSelector,
  (accountList) => {
    return (accountList || []).filter(({ docket }) => activeDocketStatuses.includes(docket?.status))
  }
)

export const activeAccountIdsReselector = createSelector(
  activeAccountListReselector,
  (accountList) => new Set(accountList.map(({ id }) => id))
)

export const budgetAccountSelector = createSelector(
  accountEntities,
  selectedBudgetAccount,
  (accounts, id) => !accounts ? null : accounts[id]
)

export const publicAccountInfo = createSelector(accountStateSelector, (state) => state.public_info)

export const hasClipboardEditingPrivileges = (account: JoiAccount) => { 
  if (!account) return false
  
  const { is_admin, is_exec, is_manager, is_leader } = account
  return is_leader || is_manager || is_exec || is_admin
}

export const clipboardEditingPrivilegesReselector = createSelector(account, hasClipboardEditingPrivileges)


export const accountSelectorDialogSelector = createSelector(
  accountListSelector,
  userSettings,
  (accounts: Account[], userSettings: UserSettings) => {
    const accountList = accounts;
    const defaultAccount = user ? accountList.find(a => a.id === userSettings.default_account) : null
    return { accountList, defaultAccount }
  }
)
export const accountSelectorDialogSelectorFilterOutTeamContributors = createSelector(
  activeAccountListReselector,
  userSettings,
  (accounts: Account[], userSettings: UserSettings) => {
    const accountList = accounts.filter(a => !a.is_solo)
    const defaultAccount = user ? accountList.find(a => a.id === userSettings.default_account) : null
    return { accountList, defaultAccount }
  }
)

export const clipboardAccountSelectionsReselector = createSelector(
  accountSelectorDialogSelector, 
  ({ accountList }) => accountList.filter(a => !a.is_invited && !a.is_solo)
)

export const adminAccountSelectionsReselector = createSelector(
  accountSelectorDialogSelector, 
  ({ accountList }) => accountList.filter(a => a.is_admin)
)

export const selectedBudgetAccountReselector = createSelector(
  adminAccountSelectionsReselector,
  selectedBudgetAccount,
  (accounts, accountId) => accounts.find(a => a.id === accountId)
)


// export const expiredOwnedAccountsReselector = createSelector(
//   user,
//   accountListSelector,
//   (user, accounts): number => !user || !accounts ? 0 : accounts.filter(account => account.owner === user.uid && account.docket && +account.docket.days_remaining < 0).length
// )

export const accountIssueReselector = createSelector(
  user,
  accountListSelector,
  (u, accounts): string => !u || !accounts ? '[]' : JSON.stringify(
    accounts.filter(acc => acc.docket && acc.admin.includes(u.uid) && (+acc.docket.days_remaining < 0 ||  ['incomplete','suspended'].includes(acc.docket.status)))
    .map(acc => ({id: acc.id, status: acc.docket.status}))
    ) // I used stringify because when it sent as an array, it fired every time accounts was updated, even if the array didn't change
)

export const accountsInvitedReselector = createSelector(
  activeAccountListReselector,
  justInvitedAccountIds,
  (accounts, justInvitedIds) => {
    const filteredSortedAccounts = accounts.filter(a=> a.is_invited || justInvitedIds.includes(a.id)).sort((a,b)=>a.title > b.title ? 1 : -1)
    // console.log({ accounts, justInvitedIds, filteredSortedAccounts })
    return filteredSortedAccounts
  }
)

export const hasInvitationsReselector = createSelector(
  accountsInvitedReselector,
  invitedToEventsReselector,
  (accounts, events) => !!accounts?.length || !!events?.length
)

export const invitedAccountIdsReselector = createSelector(
  accountsInvitedReselector,
  (invitedAccounts) => new Set(invitedAccounts.map(account => account.id))
)

export const validEventBearingAccountIds = createSelector(
  accountIds,
  accountEntities,
  accountsLoading,
  (ids, accounts, accountsLoading ) => ({ ids: [...ids].filter(id=>{
    // console.log({id, account:accounts[id]})
    return !accounts[id].is_invited && !accounts[id].is_solo
  }), accountsLoading })
)

export const accountsAlphabetic = createSelector(
  accountListSelector,
  (accounts)=>accounts.filter(a=>!a.is_invited).sort((a,b)=>a.title > b.title ? 1 : -1)
)



export const accountsHeldReselector = createSelector( // Careful of infinite loops!
  publicAccountInfo,
  user,
  (public_info: Dictionary<AccountPublicInfo>, user: User) => !user || !user.accounts || !public_info ? [] :  Object.values(public_info).filter(account => user.accounts.includes(account.id))
)


export interface UnsubscribedAccountIdsByEmail {
  [id:string]: Set<string>
}

export const unsubscribedAccountIdsByEmailReselector = createSelector(
  workforce,
  accountIdListByEmail,
  accountsHeldReselector,
  (workers, accountIdListByEmail, accountsHeld) => {
    const workerEmails = workers.map(w => w.email)
    const accountsHeldIds = accountsHeld.map(a => a.id)
    const unsubscribedAccountIdsByEmail: UnsubscribedAccountIdsByEmail = {}

    workerEmails.forEach(email => unsubscribedAccountIdsByEmail[email] = new Set(accountsHeldIds.filter(
      accountId => !accountIdListByEmail[email] || !accountIdListByEmail[email].includes(accountId)
    )))

    return unsubscribedAccountIdsByEmail
  }
)

export const missingPublicInfoIdsReselector = createSelector(
  publicAccountInfo,
  user,
  (public_info: Dictionary<AccountPublicInfo>, user: User) => {
    // missingPublicInfoIds is currently used by accounts.service to load any public infos in user.accounts (from the store) that are not already loaded.
    const publicInfoList = Object.values(public_info)
    if (!user || !user.accounts || !user.accounts.length || !publicInfoList.length) {
      return [] // don't want to trigger any downloads of public_infos before the current account is present in public_info (should be loaded in automatically) and user.accounts is loaded
    }
    const accountsHeld = publicInfoList.filter(account => user.accounts.includes(account.id))
    const accountsHeldIds = new Set(accountsHeld.map(account => account.id))
    const missingPublicInfoIds = user.accounts.filter(accountId => !accountsHeldIds.has(accountId))
    // if (missingPublicInfoIds.length) console.log({ accountsHeld, accountsHeldIds, missingPublicInfoIds, publicInfoList })
    return missingPublicInfoIds
  }
)

export const getAccountEventLabels = (account: Account) => (account && account.labels ?
  {
    accountEventLabelsById: makeMapFromListOfObjectsAndKey<Label>(account.labels, 'id') as Dictionary<Label>,
    accountEventLabelsList: account.labels
  } :
  {
    accountEventLabelsById: makeMapFromListOfObjectsAndKey<Label>(UiService.makeDefaultLabels(), 'id') as Dictionary<Label>, accountEventLabelsList: UiService.makeDefaultLabels()
  }
)

export const selectedEventLabels = createSelector(
  account,
  getAccountEventLabels
)

export const accountsTrialDays = createSelector(
  accountListSelector,
  user,
  account,
  (accounts, u, eventAccount): AccountIssueDisplayData => {
    const allAccounts = (eventAccount ? [eventAccount] : []).concat(accounts) // when you load an event, the account list is eventually unloaded from the store, so you still need to check the loaded account for free trial status
    return allAccounts
      .filter(a=>((a.admin && a.admin.includes(u.uid)) || (a.executive && a.executive.includes(u.uid))) && !a.is_invited && a.docket && a.docket.days_remaining && a.docket.status === 'trial')
      .map((acc):AccountIssueDisplayData => ({id: acc.id, status: acc.docket.status, days_remaining: +acc.docket.days_remaining}))
      .reduce((prev,curr)=>curr.days_remaining < prev.days_remaining ? curr : prev, { id:null, status:null, days_remaining:32})
  }
)
